<header class="sub-page-layout__header paymentCodes__header">
  <div class="paymentCodes__header-text h2 h2--semi-bold">Payment Codes</div>
  <mat-slide-toggle
    class="paymentCodes__active-toggle"
    [checked]="activeFilter === 'active'"
    color="primary"
    (change)="showInactiveChanges($event)"
  >
    <div *ngIf="activeFilter !== 'inactive'">Active</div>
    <div *ngIf="activeFilter === 'inactive'">Inactive</div>
  </mat-slide-toggle>
  <button mat-flat-button color="primary" class="paymentCodes__add-item" (click)="uploadCodes()" *ngIf="!viewOnly">
    <mat-icon>file_upload</mat-icon> Upload Payment Codes
  </button>
  <button mat-flat-button color="primary" class="paymentCodes__add-item" (click)="addPaymentCode()" *ngIf="!viewOnly">
    <mat-icon>add_circle_outline</mat-icon> Add Payment Code
  </button>
</header>
<div *ngIf="dataSource && gridConfig" class="lib-grid__grid-container">
  <lib-grid [dataSource]="dataSource" [gridConfiguration]="gridConfig" skipLoadOnInit="true" loadAfterInit="true">
    <div class="">
      <h4>No Payment Codes Found.</h4>
    </div>
  </lib-grid>
</div>
<footer *ngIf="isImplementation && itemCount > 0" class="paymentCodes__footer">
  <lib-button-loading color="primary" class="paymentCodes__button" [invalid]="itemCount === 0" (clickEvent)="next()"
    >Next
  </lib-button-loading>
</footer>
